// extracted by mini-css-extract-plugin
export default {"root_scroller":"YW","flex_container":"ZW","container":"aX","scroller":"bX","indicator":"cX","scrollButtons":"eX","selected":"fX","root_tab":"gX","root_tab_scrollable":"hX","root_scroller_mob":"iX","scroller_mob":"jX","indicator_mob":"kX","selected_mob":"lX","root_tab_mob":"mX","root_tab_mob_scrollable":"nX"};
    if(module.hot) {
      // 1715188239129
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  